import { render } from "./SupplierReturnsView.vue?vue&type=template&id=2ba485bb"
import script from "./SupplierReturnsView.vue?vue&type=script&lang=js"
export * from "./SupplierReturnsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__